/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { saveAs } from 'file-saver';
import { AxiosInstance } from 'axios';
import contentDisposition from 'content-disposition';

import { baseUrl, NotaryAPI } from './types';

export const notaryJournalClient = (request: AxiosInstance) => ({
  async getJournalEntries(limit: number, offset: number): Promise<NotaryAPI.JournalEntriesListResponse> {
    return (await request.get(`${baseUrl}/journal`, { params: { limit, offset } })).data;
  },

  async getJournalEntry(id: string): Promise<NotaryAPI.JournalEntryResponse> {
    return (await request.get(`${baseUrl}/journal/${id}`)).data;
  },

  async patchJournalEntry(id: string, entryValue: any): Promise<void> {
    await request.patch(`${baseUrl}/journal/${id}`, entryValue);
  },

  async lockJournalEntry(id: string): Promise<void> {
    await request.post(`${baseUrl}/journal/${id}/lock`);
  },

  async exportJournalEntry(id: string): Promise<any> {
    const res = await request.get(`${baseUrl}/journal/${id}/export`, {
      responseType: 'blob',
    });
    const cd = contentDisposition.parse(res.headers['content-disposition'] as string);
    const file = new Blob([res.data], {
      type: 'application/pdf',
    });
    saveAs(file, cd.parameters.filename);
  },
});
